import {
    AnimationBaseController,
    GameRandom,
    IAnimationControllerConfiguration,
    Inject,
    SoundType,
} from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { AnimationContents } from "../../AnimationContents";
import { GameLogic } from "../../../Logic/GameLogic";
import { Debug } from "../../../Utils/Debug";
import CommonRuleConstants from "../../../Constants/CommonRuleConstants";
import { PlayerInnerController } from "./PlayerInnerController";
import { ModelEventConstants } from "../../../Constants/ModelEventConstants";
import { SoundConstants, SoundLevels } from "../../../Constants/SoundConstants";
import { StopperNamesConstants } from "../../../Constants/StopperNamesConstants";
import { PlayerJumpingStateConstants } from "../../../Constants/PlayerJumpingStateConstants";

export interface IPlayerControllerOptions {
}

export class PlayerController extends AnimationBaseController {
    $model: GameModel;
    interval: any;
    public constructor(@Inject private _options: IPlayerControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("PlayerController");
        console.log('PlayerController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: "player",
            childControllers: {
                PlayerInner: {
                    model: this.$model,
                    controller: PlayerInnerController,
                    instanceName: 'player_inner'
                }
            },
            modelWatch: {
                "player.isRun": (run: boolean) => {
                    if (run && this.$model.player.lives < CommonRuleConstants.MaxLives) {
                        this.gotoAndPlay('blink');
                    }

                    if (run) {
                        if (!this.soundManager.isSoundPlaying(SoundConstants.FOOTSTEP_1)) {
                            this.soundManager.getSoundById(SoundConstants.FOOTSTEP_1).delay = 0.1;
                            this.soundManager.play(SoundConstants.FOOTSTEP_1, true, SoundLevels.running);
                        }
                    } else {
                        this.soundManager.stop(SoundConstants.FOOTSTEP_1);
                    }
                },
                "player.pos.y": (y: number, prevY: number) => {
                    this.y = y;

                },
                "player.jumpingState": (state: PlayerJumpingStateConstants) => {
                    if (state === PlayerJumpingStateConstants.None && this.$model.player.isRun) {
                        this.soundManager.play(SoundConstants.FOOTSTEP_1, true, SoundLevels.running);
                    } else if (state !== PlayerJumpingStateConstants.None) {
                        this.soundManager.stop(SoundConstants.FOOTSTEP_1);
                    }
                },
                "player.pos.x": (x: number) => {
                    this.x = x;
                },
                "distance": (distance: number) => {
                    this._setDistance();
                },
                "pause": (value: boolean) => {
                    if (value) {
                        this.soundManager.stop(SoundConstants.FOOTSTEP_1);
                    } else {
                        if (this.$model.player.isRun) {
                            if (!this.soundManager.isSoundPlaying(SoundConstants.FOOTSTEP_1)) {
                                this.soundManager.getSoundById(SoundConstants.FOOTSTEP_1).delay = 0.1;
                                this.soundManager.play(SoundConstants.FOOTSTEP_1, true);
                            }
                        }
                    }
                }
            },
            modelEvents: {
                [ModelEventConstants.PLAYER_JUMP]: () => {
                    this.soundManager.playSound(SoundConstants.JUMP, 0, SoundLevels.running);
                },
                [ModelEventConstants.PLAYER_DOUBLE_JUMP]: () => {
                    //this.soundManager.playSound(SoundConstants.DOUBLE_JUMP, 0, SoundLevels.running);
                },
                [ModelEventConstants.COLLISION_OUTFIT]: () => {
                    this.getDisplayObjectByQuery('plusfive')[0].visible = true;
                    clearTimeout(this.interval);
                    this.interval = setTimeout(() => {
                        this.getDisplayObjectByQuery('plusfive')[0].visible = false;
                    }, 400);
                },
                [ModelEventConstants.COLLISION_STOPPER]: (name: StopperNamesConstants) => {
                    const isMetal = [
                        StopperNamesConstants.Bicycle,
                        StopperNamesConstants.Gidrant,
                        StopperNamesConstants.Mail,
                        StopperNamesConstants.Urn,
                    ].indexOf(name) > 0;

                    if (isMetal) {
                        this.soundManager.playSound(SoundConstants.METAL_HIT, 0, SoundLevels.running);
                    } else {
                        this.soundManager.playSound(SoundConstants.WOODEN_HIT, 0, SoundLevels.running);
                    }
                },
            },
            sounds: [
                {
                    id: SoundConstants.JUMP,
                    type: SoundType.SFX
                },
                {
                    id: SoundConstants.DOUBLE_JUMP,
                    type: SoundType.SFX
                },
                {
                    id: SoundConstants.METAL_HIT,
                    type: SoundType.SFX
                },
                {
                    id: SoundConstants.WOODEN_HIT,
                    type: SoundType.SFX
                },
                {
                    id: SoundConstants.FOOTSTEP_1,
                    type: SoundType.SFX
                },
                {
                    id: SoundConstants.CROWD_1,
                    type: SoundType.SFX
                },
                {
                    id: SoundConstants.CROWD_2,
                    type: SoundType.SFX
                },
                {
                    id: SoundConstants.CROWD_3,
                    type: SoundType.SFX
                },
            ]
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(0);
        const { x, y } = this.$model.player.pos;
        this.x = x;
        this.y = y;

        this.getDisplayObjectByQuery('plusfive')[0].y = -500;
        this.getDisplayObjectByQuery('plusfive')[0].x = 100;
        this.getDisplayObjectByQuery('plusfive')[0].visible = false;

        this._setDistance();
        Debug.drawAABB(this, this.$model.player);
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

    private _setDistance() {
        this.setTextByQuery('position.text', /*`${this.$model.distance.toFixed(0)}ft`*/ '');
    }

    protected onDestroy() {
        this.soundManager.stop(SoundConstants.FOOTSTEP_1);
    }
}

